<template>
  <div>
    <h3 class="header">Create Registration</h3>
    <v-stepper v-model="regStage" non-linear vertical>
      <v-stepper-step :complete="selectedChild !== null" step="1">
        Select Child
        <small v-if="selectedChild !== null">Selected: {{ selectedChild.firstName + ' ' + selectedChild.lastName }}</small>
      </v-stepper-step>
      <v-stepper-content step="1">
        <v-layout row wrap height="200px" class="mb-5">
          <v-flex xs12>
            <bb-select-children :children="children" v-model="selectedChild" @input="testFunc"></bb-select-children>
          </v-flex>
        </v-layout>
        <v-btn color="primary" @click.native="regStage += 1" :disabled="selectedChild === null">Continue</v-btn>
      </v-stepper-content>
      <v-stepper-step :complete="regStage > 2" step="2" :editable="selectedChild !== null">
        After 4
      </v-stepper-step>
      <v-stepper-content step="2">
        <v-btn color="primary" @click.native="regStage -= 1" flat>
          <v-icon>chevron_left</v-icon>Back</v-btn>
        <!-- <v-btn color="primary" @click.native="regStage = 3" flat>Next<v-icon right>chevron_right</v-icon></v-btn> -->
        <v-layout row wrap>
          <v-flex xs12>
            <after-course-overview v-if="selectedChild" :courses="courses.filter(course => { return course.type === 'After 4' && course.homeroom.grade === selectedChild.homeroom.grade; })" :selectedChild="selectedChild"></after-course-overview>
          </v-flex>
        </v-layout>
        <v-btn color="primary" @click.native="regStage += 1" class="right">Continue</v-btn>
      </v-stepper-content>
      <v-stepper-step :complete="regStage > 3" step="3" :editable="selectedChild !== null">
        Beit Bialik
      </v-stepper-step>
      <v-stepper-content step="3">
        <v-btn color="primary" @click.native="regStage -= 1" flat>
          <v-icon>chevron_left</v-icon>Back</v-btn>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <vc-date-picker v-model="date" scrollable full-width color="blue" mode="multiple" popoverVisibility="visible">
            </vc-date-picker>
            <!-- <v-date-picker v-model="date" scrollable full-width @input="pickerDate" color="blue" year-icon="mdl-calendar-blank">
            </v-date-picker> -->
          </v-flex>
          <v-flex xs12 sm6>
            <bb-course-overview :courses="courses.filter(course => { return course.type == 'Beit Bialik'; })" ref="courseSelection"></bb-course-overview>
          </v-flex>
        </v-layout>
        <v-btn color="primary" @click.native="regStage += 1" class="right">Continue</v-btn>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import BbCourseOverview from "./BbCourseOverview";
import AfterCourseOverview from "./AfterCourseOverview";
import BbSelectChildren from "./fields/BbSelectChildren";
import { HTTP } from "./http-common";

export default {
  components: {
    BbCourseOverview,
    AfterCourseOverview,
    BbSelectChildren
  },
  data() {
    return {
      regStage: 1,
      courses: [],
      date: [],
      children: [],
      selectedChild: null
    };
  },
  methods: {
    pickerDate(val) {
      console.log(val);
      this.$refs.courseSelection.stage = 1;
    },
    /**
     * Retrieves courses.
     * @todo Filter by selectedChild. */
    getCourses() {
      HTTP.get("courses?_expand=homeroom")
        .then(response => {
          this.courses = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    /**
     * Retrieves children.
     * @todo Filter by logged in user.
     */
    getChildren() {
      HTTP.get("userProfiles?userRoleId=1&_expand=homeroom")
        .then(response => {
          this.children = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    testFunc() {
      console.log(typeof this.selectedChild);
    }
  },
  mounted: function() {
    this.getChildren();
    console.log(JSON.stringify(this.children));
    this.getCourses();

    setInterval(
      function() {
        this.getCourses();
      }.bind(this),
      5000
    );
  }
};
</script>
